
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Panel from 'vux/src/components/panel/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import OrderPanel from '../widget/OrderPanel'

export default {
directives: {
TransferDom
},
components: {
XHeader,
Actionsheet,
Panel,
Search,
Loading,
Scroller,
Tab,
TabItem,
OrderPanel
},
name: 'GoodsList',
data () {
return {
menus: {

'1': '待支付',
'2': '已支付'
},
showMenus: false,
goodsList: [],
scrollTop: 0,
footer: {
title: '',
url: '/goods/goods_list'
},

searchTerm: '',
isOnSale: 1, // 选项卡默认未支付 支付状态1、未支付 2、已支付
keyword: '',
page: 1,
pullupDefaultConfig: {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
},
pageCount: 1,
title: '待支付'
}
},
created () {
this.page = 1
this.goodsList.length = 0
this.reloadGoods()
},







methods: {

handlerChange (key) {
key = key + 1
if (key === 1) {
this.title = '未支付'
} else if (key === 2) {
this.title = '已支付'
}
this.isOnSale = key
this.page = 1
this.keyword = ''
this.goodsList.length = 0
this.$refs.scrollerView.reset()
this.reloadGoods()
},
reloadGoods () {
const payload = {
isOnSale: this.isOnSale, // 状态
keyword: this.keyword, // 搜索框
page: this.page 
}
const that = this
that.$vux.loading.show({
text: '商品加载中...'
})
this.$store.dispatch('getOrderGoodsList', payload).then((res) => {
console.log(res)
that.pageCount = res.pageCount

if (res.data.length === 0) {
that.goodsList = []
} else {
res.data.forEach((e) => {
e.order_amount = this.roundValue(parseFloat(e.order_amount))
e.all_cost_ = this.roundValue(parseFloat(e.all_cost_))
e.order_goods.forEach((r) => {
r.final_price = this.roundValue(parseFloat(r.final_price))
r.true_cost_price_ = this.roundValue(parseFloat(r.true_cost_price_))
r.order_status = e.order_status
r.pay_status = e.pay_status
})
})
res.data.forEach((e) => {
that.goodsList.push(e)
})
}




const isLastPage = that.page >= that.pageCount
if (isLastPage) {
this.$refs.scrollerView.disablePullup()
} else {
this.$refs.scrollerView.enablePullup()
this.$refs.scrollerView.donePullup()
}
this.searchTerm = payload.keyword
that.page = res.pageNext
that.$vux.loading.hide()
})
},
onSearchGoods () {
this.keyword = this.searchTerm
this.page = 1
this.goodsList.length = 0
this.goodsList = []
this.$refs.scrollerView.reset()
this.reloadGoods()
},
onImgError (item, $event) {
console.log(item, $event)
},
loadMoreData () {
console.log('加载条数页数' + this.page + '-' + this.pageCount)
if (this.page <= this.pageCount) {

this.reloadGoods()
}
},
cutstr (str, len) {
return String(str).substring(0, len) + '..'
},

roundValue (val) {
return Math.round(val * 100) / 100
},
doSelect (key) {
if (key === '1') {
this.title = '已支付'
} else if (key === '0') {
this.title = '未支付'
}
this.isOnSale = key
this.page = 1
this.keyword = ''
this.goodsList.length = 0
this.$refs.scrollerView.reset({top: 0})
this.reloadGoods()
}
}
}



// WEBPACK FOOTER //
// ./src/components/order/OrderList.vue